module.exports = __webpack_public_path__ + "static/media/projects-icon.2ce06109.svg";